<template>
  <div class="check">
    <p>{{ $t('order.check.checkTip') }}{{ checkInfo.check_result == 2 ? $t('order.check.businessAddr') : $t('order.check.residentialAddr') }}</p>
    <div class="check-btn">
      <el-button type="primary" @click="handleSure" size='small'>{{ $t('order.check.confirmBtn') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checkInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    handleSure(){
      this.$emit('closeCheck')
    }
  }
}
</script>
<style lang="scss" scoped>
  .check{
    font-size: 14px;
    p{
      font-size: 14px;
      line-height: 16px;
    }
  }
  .check-btn{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;
  }
</style>